import { getSubscriptionService } from '@/core/container/ioc'

const updateTooltipPositionEventName = 'updateTooltipPosition'

export const useTooltipPositionUpdating = () => {
  const subscriptionService = getSubscriptionService()

  const updateTooltipPosition = () => {
    subscriptionService.emit(updateTooltipPositionEventName, undefined)
  }

  const subscribeToUpdateTooltipPosition = (callback: () => void) => {
    return subscriptionService.subscribe(updateTooltipPositionEventName, callback)
  }

  const unsubscribeFromUpdateTooltipPosition = (subscriptionId: string) => {
    subscriptionService.unsubscribe(subscriptionId)
  }

  return {
    updateTooltipPosition,
    subscribeToUpdateTooltipPosition,
    unsubscribeFromUpdateTooltipPosition,
  }
}
